module.exports = __webpack_public_path__ + "static/mural-7-fee85d2e4fde844c3487ce6a321b0c89.jpg";